module.exports = __webpack_public_path__ + "img/zoom.d01c5893.svg";